import biblioLogo from './Biblio_HZ.svg'
import documentPlus from './document-plus.svg'
import notificationBell from './notification-bell.svg'
import profile from './profile.svg'
import settings from './settings.svg'
import share from './share.svg'
import sharedLinks from './shared-links.svg'
import archive from './archive.svg'
import alerts from './alerts.svg'
import signOut from './sign-out.svg'
import userProfile from './user-profile.svg'
import backButton from './back.svg'
import closeButton from './close.svg'
import verifiedCheck from './verified-check.svg'
import whiteVerifiedCheck from './white-verified-check.svg'
import threeDotsVertical from './settings-vertical.svg'
import document from './document.svg'
import checkmark from './checkmark.svg'
import checkmarkBlue from './verified-check-blue.svg'
import takePhoto from './take-photo.svg'
import upload from './upload.svg'
import calendar from './calendar.svg'

const Images = {
    biblioLogo,
    documentPlus,
    notificationBell,
    profile,
    settings,
    share,
    sharedLinks,
    archive,
    alerts,
    signOut,
    userProfile,
    backButton,
    closeButton,
    verifiedCheck,
    threeDotsVertical,
    document,
    checkmark,
    checkmarkBlue,
    takePhoto,
    upload,
    calendar,
    whiteVerifiedCheck
}

export default Images
